









































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {CardForm, DialogForm} from '@/components/bwaff';
import moment from 'moment';


@Component({
  components: {
    CardForm,
    DialogForm,
  }
})
export default class Details extends Vue {
  @Prop({default: 'DD MMMM YYYY'}) 
  format: string;

  moment = moment;

  open_promo() {
    this.bus.emit('open-dialog', { name: 'PromoCode' });
  }

  get open_promoDisabled() {
    return this.$store.state.billingCustomer?.balance > 0
  }

  get customerBalance() {
    return this.$store.state.billingCustomer?.balance
  }

  open_change_plan() {
    this.bus.emit('open-dialog', { name: 'ChangePlanDialog' });
  }

  get billing(){
    return this.$store.state.billing as Billing.Subscription
  } 
}
